import emailjs from '@emailjs/browser';

const EmailNotificationFromContactForm = ({subject, fromName, fromEmail, message}) => {
    //setting up for emailjs service
    const serviceID = 'service_e1wzscb'
    const templateId ='template_gstzmkc'
    const publicKey = 'njUnqN5sBkR7cMmkd'
        
    const templateParams ={
    subject_line: subject,
    from_name: fromName,
    from_email:fromEmail,
    message: message
    }

    emailjs.send(serviceID, templateId, templateParams,publicKey)
    .then((response) => {
      console.log('Email sent successfully', response)
    }).catch((error)=>{
      console.log('Error sending email:', error)
    })
}

export default EmailNotificationFromContactForm
